<script setup>
// ios에서 tab이 안바뀌는 현상이 있어서 추가
const changeTab = (index) => {
  if (window.webkit && window.webkit.messageHandlers.changeTab) {
    window.webkit.messageHandlers.changeTab.postMessage(index);
  }
}
window.changeTab = changeTab;
</script>

<template>
  <router-view v-slot="{ Component, route }">
    <!-- meta.keepAlive 속성이 있는 화면만 캐싱 -->
    <keep-alive>
      <component :is="Component" :key="route.name" v-if="route.meta.keepAlive" />
    </keep-alive>
    <!-- 캐싱이 필요 없는 화면 (상세 등) -->
    <component :is="Component" :key="route.fullPath" v-if="!route.meta.keepAlive" />
  </router-view>
</template>

<style scoped></style>